import { render, staticRenderFns } from "./MarketsBuy.vue?vue&type=template&id=5f41188a&scoped=true"
import script from "./MarketsBuy.vue?vue&type=script&lang=js"
export * from "./MarketsBuy.vue?vue&type=script&lang=js"
import style0 from "./MarketsBuy.vue?vue&type=style&index=0&id=5f41188a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f41188a",
  null
  
)

export default component.exports